var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "row mt-2 align-items-center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-5" },
          [
            _c(_setup.ModalImportSearch, {
              on: { "search-text-change": _setup.updateSearchText },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(_setup.ModalImportList, {
        staticClass: "mt-2 mb-4",
        attrs: { items: _setup.items, "is-loading": _setup.isLoading },
        on: { "item-selected": _setup.itemSelected },
      }),
      _vm._v(" "),
      _c("b-pagination", {
        attrs: {
          "total-rows": _setup.totalTemplates,
          "per-page": _setup.perPage,
          "aria-controls": "my-table",
          align: "center",
        },
        model: {
          value: _setup.currentPage,
          callback: function ($$v) {
            _setup.currentPage = $$v
          },
          expression: "currentPage",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-12 col-sm-7" }, [
      _c("h6", { staticClass: "font-weight-bold no-wrap mb-0" }, [
        _vm._v("Select a template"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }